import React, { useEffect, useState } from "react";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import { navLinks } from "./AutoSeriesView";
import Content from "../../components/content/Content";
import DataTable from "../../components/data-table/DataTable";
import { useTranslation } from "react-i18next";
import ActionButton from "../../components/button/ActionButton";
import AnyField from "../../components/fields/AnyField";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { getAccessToken } from "../../services/baseReuqest";
import { Dialog, DialogActions, DialogContent, DialogTitle, MenuItem } from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import { history } from "../../history";
import { getAllAutoSeries } from "../../services/autoSeries";

const useStyles = makeStyles(theme => ({
    btn: {
        backgroundColor: "#FFFFFF",
        border: "0.5px solid #00000014",
        cursor: "pointer",
        padding: "6px 16px",
        borderRadius: "8px",
        transition: "color 0.3s ease",
        color: "#000000",
        fontWeight: "400",
        lineHeight: "20px",
        fontSize: "14px",
        letterSpacing: "-0.7px",
        textDecoration: "none",
        boxShadow: "0px 3px 1px 0px #0000000A",


        "&:hover": {
            color: "#9C27B0",
        },
    },
    btnGreen: {
        backgroundColor: "#34B41F",
        border: "0.5px solid #00000014",
        cursor: "pointer",
        padding: "6px 16px",
        borderRadius: "8px",
        transition: "background-color 0.3s ease",
        color: "#FFFFFF",
        fontWeight: "400",
        lineHeight: "20px",
        fontSize: "14px",
        letterSpacing: "-0.7px",
        textDecoration: "none",
        boxShadow: "0px 3px 1px 0px #0000000A",


        "&:hover": {
            backgroundColor: "#138700",
        },
    },
    marginBtn: {
        marginBottom: "20px"
    },
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    containerBtn: {
        display: "flex",
        flexDirection: "column",
        gap: "8px"
    },
    progressContainer: {
        width: '100%',
        height: 8,
        backgroundColor: '#E9EAEB',
        borderRadius: 4,
        overflow: 'hidden',
        marginTop: 4,
    },
    progressBar: {
        height: '100%',
        backgroundColor: '#9C27B0',
        transition: 'width 0.3s ease',
    },
    textDecoration: {
        color: "#0000EE!important",
    },
    dialogContainer: {
        minWidth: "579px",
        maxWidth: "579px",
        padding: "24px 8px"
    },
}))

export default function InstancesPage() {
    const {t} = useTranslation();
    const classes = useStyles();

    const [isOpen, setIsOpen] = useState(false);
    // const [rowData, setRowData] = useState({});
    // const [originalRowData, setOriginalRowData] = useState({});
    const [refreshTable, setRefreshTable] = useState(false);
    const [successDialog, setSuccessDialog] = useState(false);
    const [errorDialog, setErrorDialog] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [stopSeriesDialog, setStopSeriesDialog] = useState(false);
    const [selectedSeriesId, setSelectedSeriesId] = useState(null);
    const [disableRequest, setDisableRequest] = useState(false);

    const [mailingList, setMailingList] = useState([]);

    const [search, setSearch] = useState({
        search: null,
        seriesTransport: null,
        seriesStatus: null,
        // channel: null,
        seriesName: '',
    });

    const [serialStatusList, setSerialStatusList] = useState([])
    const columnData = [
        {
            id: 'name',
            numeric: false,
            disableSorting: true,
            label: 'Serial name',
            minWidth: '20vw',
            colorField: "#0000EE",
            processValue: (val, _, rowX) => {
                let newName = rowX.name;

                if (rowX.serialNumber > 0) {
                    if (/\(\d+\)$/.test(newName)) {
                        newName = `${newName} (${rowX.serialNumber})`;
                    } else {
                        newName = `${newName} (${rowX.serialNumber})`;
                    }
                }

                return(
                    <>
                        {newName}
                    </>
                )
            }
        },
        { id: 'dateStart', numeric: false, disableSorting: false, label: 'Date start serial' },
        { id: 'dispatchPeriod', numeric: false, disableSorting: true, label: 'Dispatch period'},
        { id: 'timeZone', numeric: false, disableSorting: true, label: 'Timezone' },
        { id: 'currentStep', numeric: false, disableSorting: true, label: 'Current step' },
        {
            id: 'completionOfCurrentStep',
            numeric: false,
            disableSorting: true,
            label: '% completion of current step',
            processValue: (val, _, rowX) => {
                const done = val.amountOfHandledSeriesActions[0] ?? 0;
                const total = val.amountOfSeriesActionsForHandle[0] ?? 100;
                const percent = total === 0 ? 0 : Math.round((done / total) * 100);

                return(
                    <>
                        {total !== 0 &&
                            <div>
                                <div>{done} из {total}</div>
                                <div className={classes.container}>
                                    <div className={classes.progressContainer}>
                                        <div
                                            className={classes.progressBar}
                                            style={{width: `${percent}%`}}
                                        />
                                    </div>
                                    <div style={{marginLeft: "12px"}}>{isNaN(percent) ? 0 : percent}%</div>
                                </div>
                            </div>
                        }
                        {total === 0 && (rowX.seriesStatus === "finished") &&
                            <div>
                                Шаг завершен
                            </div>
                        }
                        {total === 0 && (rowX.seriesStatus === "stopped") &&
                            <div>
                                Шаг остановлен
                            </div>
                        }
                        {total === 0 && rowX.seriesStatus !== "finished" && rowX.seriesStatus !== "stopped" &&
                            <div>
                                Ожидается старт шага...
                            </div>
                        }
                    </>
                )
            }
        },
        {
            id: 'seriesStatus', numeric: false, disableSorting: true, label: 'Serial status',
            processValue: (val, _, rowX) => {
                const handlePause = () => {
                    pauseSerial(rowX.seriesId)
                };

                const handleResume = () => {
                    resumeSerial(rowX.seriesId)
                };

                const handleStop = () => {
                    // stopSerial(rowX.seriesId)
                    setSelectedSeriesId(rowX.seriesId);
                    setStopSeriesDialog(true);
                };

                return (
                    <div className={classes.container}>
                        <div>{t(val)}</div>
                        {val === "active" ? (
                            <div className={classes.containerBtn}>
                                <button onClick={handlePause} disabled={disableRequest} className={classes.btn}>{t("On pause")}</button>
                                <button onClick={handleStop} className={classes.btn}>{t("On stop")}</button>
                            </div>
                        ) : val === "paused" ? (
                            <div className={classes.containerBtn}>
                                <button onClick={handleResume} disabled={disableRequest} className={classes.btnGreen}>{t("Resume series")}</button>
                                <button onClick={handleStop} className={classes.btn}>{t("On stop")}</button>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                );
            }
        },
    ]

    useEffect(() => {
        getStatusSeries();
        getAllTransport();
    }, []);

    const getTableData = async (page, per_page, order, order_by) => {
        const { seriesTransport, seriesStatus, seriesName } = search;

        const filter = {
            seriesTransport,
            seriesStatus,
            seriesName,
        };

        const response = await getAllAutoSeries(page, per_page, order, order_by, { filter });

        if (!response.success) {
            return response
        }

        const newData = response.data.map(item => {
            return ({
                ...item,
                dispatchPeriod: `с ${item.timeOfStartSending} до ${item.timeOfEndSending}`,
                currentStep: `${item.actualStep} из ${item.seriesSteps?.length}`,
                completionOfCurrentStep: {
                    amountOfSeriesActionsForHandle: item.seriesSteps.filter(i => i.stepNumber === item.actualStep).map(a => a.amountOfSeriesActionsForHandle),
                    amountOfHandledSeriesActions: item.seriesSteps.filter(i => i.stepNumber === item.actualStep).map(a => a.amountOfHandledSeriesActions)
                }
            })
        });

        return {
            ...response,
            data: newData
        };
    };

    const openMenuDialog = (row) => {
        // setRowData(row);
        // setOriginalRowData(row);
        setIsOpen(!isOpen);
    };

    const createSerial = () => {
        history.push('/auto-series/edit/0');
    }

    const updateSeries = () => {
        setRefreshTable(!refreshTable);
    }

    const getStatusSeries = () => {
        fetch('/api/auto-series/statuses-for-filter',{
            method: "GET",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            },
        }).then(res => {
            return res.json();
        }).then(data => {
            if (data?.statuses) {
                setSerialStatusList(data.statuses.map(val => {
                    return {
                        text: val,
                        value: val
                    }
                }));
            }
        })
    }

    const getAllTransport = () => {
        fetch('/api/transport/all-for-filter', {
            method: "GET",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            },
        }).then(res => {
            return res.json();
        }).then(data => {
            if (data?.transports) {
                setMailingList(data.transports.map(val => {
                    return {
                        ...val,
                        text: val.name,
                        value: val.name
                    }
                }))
            }
        })
    }

    const pauseSerial = (seriesId) => {
        setDisableRequest(true);
        fetch(`/api/series/${seriesId}/pause-from-table`, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            },
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.success) {
                successResponse();
                setRefreshTable(!refreshTable);
            } else {
                errorOccurred();
                setErrorMessage(data.error.message);
            }
            setDisableRequest(false);
        });
    }

    const handleChange = (prop) => (event) => {
        let value;

        if (Array.isArray(event?.target?.value)) {
            value = event.target.value;
        } else {
            value = event.target.value;
        }

        setSearch((prev) => ({
            ...prev,
            [prop]: value,
        }));
    };

    const handleClickSearch = () => {
        setRefreshTable(!refreshTable);
    };

    const resumeSerial = async (seriesId) => {
        try {
            setDisableRequest(true);

            const response = await fetch(`/api/series/${seriesId}/resume-from-table`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${getAccessToken()}`
                },
            });

            const text = await response.text();

            const jsonStart = text.indexOf('{');
            if (jsonStart === -1) {
                console.log('json не найден');
                errorOccurred();
                setDisableRequest(false);
                return;
            }

            const data = JSON.parse(text.slice(jsonStart));

            if (data.success) {
                successResponse();
                setRefreshTable(!refreshTable);
            } else {
                errorOccurred();
                setErrorMessage(data.error?.message || 'Ошибка');
            }
        } catch (err) {
            console.error(err);
            errorOccurred();
            setErrorMessage(err instanceof Error ? err.message : String(err));
        } finally {
            setDisableRequest(false);
        }
    }

    const stopSerial = () => {
        setDisableRequest(true);
        fetch(`/api/series/${selectedSeriesId}/stop-from-table`, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${getAccessToken()}`
            },
        }).then((response) => {
            return response.json();
        }).then((data) => {
            if (data.success) {
                // successResponse();
                setRefreshTable(!refreshTable);
                setStopSeriesDialog(false);
                setSelectedSeriesId(null);
            } else {
                errorOccurred();
                setErrorMessage(data.error.message);
                setStopSeriesDialog(false);
                setSelectedSeriesId(null);
            }
            setDisableRequest(false);
        });
    }

    const deleteFilters = () => {
        setSearch({
            search: null,
            seriesTransport: null,
            seriesStatus: null,
            seriesName: '',
        })

        setRefreshTable(!refreshTable);
    };

    const successResponse = () => {
        setSuccessDialog(true);
        setTimeout(() => {
            setSuccessDialog(false);
        }, 2000)
    };

    const errorOccurred = () => {
        setErrorDialog(true);
        setTimeout(() => {
            setErrorDialog(false);
            setErrorMessage('');
        }, 2000)
    };

    return (
        <>
            <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                <AnyField
                    label={t('Serial name')}
                    fullWidth
                    value={search.seriesName}
                    onChange={handleChange('seriesName')}
                    onEnter={(e) => handleClickSearch(e)}
                />
                <AnyField
                    label={t('Mailing list')}
                    value={search.seriesTransport || []}
                    onChange={handleChange('seriesTransport')}
                    fullWidth
                    select
                    SelectProps={{
                        multiple: true,
                        displayEmpty: true,
                        renderValue: selected => {
                            return mailingList
                                .filter(item => selected.indexOf(item.id) > -1)
                                .map(item => item.text)
                                .join(', ');
                        },
                    }}
                >
                    {mailingList.map(item => (
                        <MenuItem key={item.id} value={item.id}>
                            <Checkbox checked={(search.seriesTransport || []).includes(item.id)} />
                            <ListItemText primary={item.text} />
                        </MenuItem>
                    ))}
                </AnyField>
                <AnyField
                    label={t('Serial status')}
                    value={search.seriesStatus || []}
                    onChange={handleChange('seriesStatus')}
                    fullWidth
                    select
                    SelectProps={{
                        multiple: true,
                        displayEmpty: true,
                        renderValue: selected => {
                            return serialStatusList
                                .filter(item => selected.includes(item.value))
                                .map(item => t(item.text))
                                .join(', ');
                        },
                    }}
                >
                    {serialStatusList.map(item => (
                        <MenuItem key={item.value} value={item.value}>
                            <Checkbox checked={(search.seriesStatus || []).includes(item.value)} />
                            <ListItemText primary={t(item.text)} />
                        </MenuItem>
                    ))}
                </AnyField>
                <ActionButton onClick={handleClickSearch} >{t("Filter")}</ActionButton>
                <ActionButton className={classes.marginBtn} onClick={deleteFilters} >{t("Delete Filters")}</ActionButton>
                <ActionButton onClick={createSerial} >{t("Create serial")}</ActionButton>
                <ActionButton onClick={updateSeries} >{t("Update statuses all serials")}</ActionButton>
            </LeftBar>
            <Content title={t("Auto series")}>
                <DataTable
                    columnData={columnData}
                    dataFunc={getTableData}
                    selector={false}
                    linkTemplate={(item) => `/auto-series/view/${item.seriesId}`}
                    onClick={openMenuDialog}
                    refresh={refreshTable}
                    pagination={true}
                />
            </Content>

            <Dialog open={successDialog} style={{ bottom: 30 }}>
                <DialogTitle id="dialog-title">{t("Success")}</DialogTitle>
            </Dialog>

            <Dialog open={errorDialog} style={{ bottom: 30 }}>
                <DialogTitle id="dialog-title">{errorMessage}</DialogTitle>
            </Dialog>
            <Dialog open={stopSeriesDialog} onClose={() => setStopSeriesDialog(false)}>
                <div className={classes.dialogContainer}>
                    <DialogTitle>Остановить серию</DialogTitle>
                    <DialogContent>
                        Вы уверены, что хотите остановить серию?
                    </DialogContent>
                    <DialogActions>
                        <ActionButton
                            fullWidth={false}
                            noMargin
                            onClick={() => setStopSeriesDialog(false)}
                            style={{ backgroundColor: "transparent", border: "1px solid #FFC107", boxShadow: "none" }}
                        >
                            {t("Cancel")}
                        </ActionButton>
                        <ActionButton
                            fullWidth={false}
                            noMargin
                            disabled={disableRequest}
                            onClick={stopSerial}
                            style={{ boxShadow: "none" }}
                        >
                            {t("Stop series")}
                        </ActionButton>
                    </DialogActions>
                </div>
            </Dialog>
        </>
    )
}